<div class="app-container" [ngClass]="{ 'custom-background': useBackgroundImage }">
    <mat-toolbar class="nav">
        <a *ngIf="logo$ | async as logo" href="/">
            <img [src]="logo | safeUrl" alt="logo" />
        </a>
    </mat-toolbar>
    <div class="app-content">
        <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
    <app-cookies-consent></app-cookies-consent>
</div>
